import { useEffect } from "react";
import AppRouters from "./router";
import { Toaster } from "./components/ui/toaster";
import ErrorBoundary from "./components/ErrorBoundary";
import { initSentry, initWebVitals } from "./utils/monitoring";

function App() {
  useEffect(() => {
    // Initialize monitoring
    initSentry();
    initWebVitals();
  }, []);

  return (
    <ErrorBoundary>
      <Toaster />
      <AppRouters />
    </ErrorBoundary>
  );
}

export default App;
